import React from 'react';
import { Link } from 'gatsby';
import { IconLogo } from '~/icons';
import * as styles from './BlogHeader.module.scss';

const BlogHeader = ({ isArchivePage }) => {

  return (
    <header className="u-header">
      {isArchivePage ? (
        <h1 className="header-col header-logo">
          <Link to="/">
            <IconLogo className={styles.iconLogo} width="153" height="40" />
          </Link>
        </h1>
      ) : (
        <div className="header-col header-logo">
          <Link to="/">
            <IconLogo className={styles.iconLogo} width="153" height="40" />
          </Link>
        </div>
      )}
      <div className={`header-title ${styles.headerTitle}`}>
        <Link to="/blog/" className="header-link">AIZULAB<br /> BLOG</Link>
      </div>
    </header>
  )
}

export default React.memo(BlogHeader);